interface NavLinkProps {
  to: string;
  label: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
}

const NavLink: React.FC<NavLinkProps> = ({
  to,
  label,
  icon,
  isActive,
  onClick,
}) => {
  return (
    <a
      href={to}
      onClick={onClick}
      className={`flex items-center px-6 py-3 text-sm transition-all duration-300 rounded-tr-lg rounded-br-lg mx-3 mb-1 ${
        isActive
          ? "text-gray-800 font-medium shadow-sm"
          : "text-gray-600 hover:text-gray-800"
      }`}
    >
      {icon && (
        <span
          className={`mr-3 ${isActive ? "text-blue-500" : "text-gray-500"}`}
        >
          {icon}
        </span>
      )}
      <span className="ml-2">{label}</span>
    </a>
  );
};

export default NavLink;
